import * as types from './action-types';
import {getAllReviews} from '../services/market-api';
import _ from 'lodash';

export function requestAllReviews() {
  return {
    type: types.REQUEST_ALL_REVIEWS
  };
}

export function receiveAllReviews(json) {
  return {
    type: types.RECEIVE_ALL_REVIEWS,
    items: _.keyBy(json, 'id'),
    receivedAt: Date.now()
  };
}


function fetchAll() {
  return dispatch => {
    dispatch(requestAllReviews());

    return getAllReviews()
      .then(json => dispatch(receiveAllReviews(json)))
      .catch(() => dispatch(receiveAllReviews([])));
  };
}

export function fetchAllReviewsIfNeeded() {
  return (dispatch, getState) => {
    const state = getState();
    if (!state.reviews.receivedAllAt) {
      return dispatch(fetchAll());
    }
  };
}



// WEBPACK FOOTER //
// ./actions/reviews.js